import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HeatPortal from "@/pages/HeatPortal";
import LandingPage from "@/pages/LandingPage";
import WhitepaperPage from "@/pages/WhitepaperPage";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { WizardProvider } from "@/lib/wizard";
import SplashScreen from "@/components/SplashScreen";

function App() {
  // Show splash exactly once per page load (state lives at App root — no
  // re-runs on tab switches inside HeatPortal).
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShowSplash(false), 3800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      {showSplash && <SplashScreen onDone={() => setShowSplash(false)} />}
      <I18nProvider>
        <WizardProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/whitepaper" element={<WhitepaperPage />} />
              <Route path="/platform" element={<HeatPortal />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </WizardProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
